module.exports = __webpack_public_path__ + "static/media/RelishLogo.1e7e1d26.png";